import type { ReactNode } from "react";

import { SiteFooter, SiteHeader } from "@/components/SiteChrome";

export function LegalPage({ eyebrow, title, intro, children }: {
  eyebrow: string;
  title: string;
  intro: string;
  children: ReactNode;
}) {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <SiteHeader regional />
      <main>
        <header className="bg-brand-dark py-16 text-background sm:py-20">
          <div className="container-page max-w-4xl">
            <span className="eyebrow">{eyebrow}</span>
            <h1 className="mt-5 text-4xl font-semibold sm:text-5xl">{title}</h1>
            <p className="mt-5 max-w-2xl text-lg leading-8 text-background/75">{intro}</p>
          </div>
        </header>
        <article className="container-page max-w-4xl py-16 sm:py-20">
          <div className="space-y-10 text-base leading-7 text-muted-foreground [&_a]:font-medium [&_a]:text-foreground [&_a]:underline [&_h2]:text-2xl [&_h2]:font-semibold [&_h2]:text-foreground [&_li]:ml-5 [&_li]:list-disc [&_p+p]:mt-4">
            {children}
          </div>
        </article>
      </main>
      <SiteFooter />
    </div>
  );
}